module.exports = __webpack_public_path__ + "static/img/BiSwiss.f5ba817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/BiSwiss.png
// module id = mDVr
// module chunks = 1